define('modules/editor/collections/sections',['require','exports','module','backbone','../models/elements/section','../models/element_factory','lib/util','../models/elements/area'],function(require, exports, module) {
  "use strict";

  var Backbone = require("backbone"),
      Section = require("../models/elements/section"),
      ElementFactory = require("../models/element_factory"),
      util = require("lib/util");

  var Serialization = {
    fromJSON: function(json) {
      //var sections = new module.exports();
      //sections.reset(_.map(json, Section.fromJSON));
      return _.map(json, Section.fromJSON);
    }
  };

  module.exports = Backbone.Collection.extend({
    model: Section,
    /*initialize: function(models, options) {
    },*/
    addBefore: function(refSection, newSection) {
      if (!this.contains(refSection))
        throw new Error("Reference not in collection");
      var refIndex = this.indexOf(refSection);
      this.add(newSection, {at: refIndex});
      this.trigger("sort");
    },
    addAfter: function(refSection, newSection) {
      if (!this.contains(refSection))
        throw new Error("Reference not in collection");
      var refIndex = this.indexOf(refSection);
      this.add(newSection, {at: refIndex + 1});
      this.trigger("sort");
    },
    moveBefore: function(refSection, targetSection) {
      if (!this.contains(refSection))
        throw new Error("Reference not in collection");
      var refIndex;
      this.remove(targetSection, {silent: true});
      refIndex = this.indexOf(refSection);
      this.add(targetSection, {at: refIndex, silent: true});
      this.trigger("sort");
    },
    moveAfter: function(refSection, targetSection) {
      if (!this.contains(refSection))
        throw new Error("Reference not in collection");
      var refIndex;
      this.remove(targetSection, {silent: true});
      refIndex = this.indexOf(refSection);
      this.add(targetSection, {at: refIndex + 1, silent: true});
      this.trigger("sort");
    },
    addElementToSection: function(section, element, position) {
      // hack: Area is not an element anymore so we create outside Elements Factory to avoid circular references
      element = element === "element:area"? this._createArea() : ElementFactory.create(element);
      section.addElement(element);
      element.setPosition(position);
      element.triggerMethod("create", section, position);
    },
    _createArea: function() {
      var Area = require("../models/elements/area");
      return new Area();
    },
    moveElementToContainer: function(container, element, position) {
      this.invoke("removeElement", element, false);
      container.addElement(element);
      element.setPosition(position);
      element.triggerMethod("move", this, container, position);
    },
    hasElement: function(elementName){
      return this.foldl(function(acc, section){
        return acc || section.hasElement(elementName);
      }, undefined);
    },
    getForm: function() {
      return this.reduce(function(form, section){
        return form || section.getForm();
      }, undefined);
    },
    findElementByClass: function(klass) {
      return this.foldl(function(acc, section) {
        return acc || section.findElementByClass(klass);
      }, undefined);
    },
    findSectionContaining: function(element) {
      return this.find(function(section) {
        return section.contains(element) || section.areasContain(element);
      });
    },
    findContainerFor: function(element) {
      return this.find(function(section) {
        return section.contains(element);
      }) || _.find(this.getAllAreas(), function(area) {
        return area.contains(element);
      });
    },
    getAllAreas: function() {
      return _.flatten(this.invoke("getAreas"));
    },
    detachElement: function(element) {
      // removes an element form its containing section
      var section = this.find(function(section) {
        return section.elements.get(element.cid);
      });
      return section && section.removeElement(element);
    }
  },
  {
    fromJSON: Serialization.fromJSON
  });

});

